import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";

import Grid from "@material-ui/core/Grid";

import Picture from "./Picture";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  photoContainer: {
    width: "72px",
    height: "72px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "10px",
    marginBottom: "10px",
  },
  deleteIcon: {
    cursor: "pointer",
    position: "absolute",
    bottom: "-7px",
    right: "-7px",
  },
  link: {
    cursor: "pointer",
    color: colors.primary,
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const InputFile = (props) => {
  const { classes, photos, setPhotos } = props;

  const handleChange = (e) => {
    let files = e.target.files;
    let newImages = [];
    for (let i = 0; i < files.length; i++) {
      // Check file extension
      if (/\.(jpe?g|JPE?G|png|PNG)$/i.test(files[i].name)) {
        let fileReader = new FileReader();
        fileReader.addEventListener(
          "load",
          function () {
            newImages.push(this.result);
            if (i === files.length - 1) {
              setPhotos([...photos, ...newImages]);
            }
          },
          false
        );
        fileReader.readAsDataURL(files[i]);
      }
    }
  };

  const removeImage = (index) => {
    setPhotos(update(photos, { $splice: [[index, 1]] }));
  };

  return (
    <Grid container direction="column">
      <Grid item style={{ marginBottom: "5px" }}>
        <label htmlFor="fileInput">
          {/* <img src={iconImg} alt="img" style={{ cursor: "pointer" }} /> */}
          {props.triggerNode || (
            <span className={classes.link}>
              {I18n.get("profiles_localStorage")}
            </span>
          )}
        </label>
        <input
          type="file"
          id="fileInput"
          onChange={handleChange}
          style={{ display: "none" }}
          multiple="multiple"
        />
      </Grid>
      <Grid item>
        <Grid container style={{ width: "313px", paddingLeft: "5px" }}>
          {photos &&
            photos.map((url, index) => (
              <Grid
                item
                key={index}
                className={classes.photoContainer}
                style={{
                  border: "1px solid " + colors.veryLighPink,
                  position: "relative",
                }}
              >
                <Picture
                  url={url}
                  maxHeight={70}
                  style={{ maxWidth: "70px", maxHeight: "70px" }}
                  alt="uploadedPicture"
                  local={true}
                />
                <img
                  onClick={() => removeImage(index)}
                  src={images.deletePhotoIcon}
                  alt="trash"
                  className={classes.deleteIcon}
                />
              </Grid>
            ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

InputFile.propTypes = {
  iconImg: PropTypes.string,
};

export default withStyles(styles)(InputFile);
